//TODO: Unittest cases should be written to improve the overall score
import { HotelBookInformationState, HotelBookInformationActions } from './hotelBookInformationReducer.types';
import { TopicValueType } from '../../../organisms/ContactUsForm/ContactUsForm.types';
export const hotelInformationInitialState: HotelBookInformationState = {
  matchedHotelsResult: null,
  matchedHotelsPropertyId: null,
  showAboutAStayOption: false,
  showTypeAndSearchWithLink: false,
  showTypeAndSearchLink: false,
  showHotelBookInfoSection: false,
  showHotelServiceDescriptionText: false,
  showHotelCreditCardReservationsText: false,
  showComments: false,
  showCommentsStillHaveAQuestionText: false,
  complimentConcernValue: null,
  showComplimentConcernAndWebsiteSupportAndMarriottBonvoySubTopic: false,
  showMarriottBonvoyAccountLabelWithLinkText: false,
  subTopicsList: null,
};

const HotelBookInfoSectionTopics: TopicValueType[] = ['FBR', 'GMF', 'GEMT'];
const TypeAndSearchWithLinkTopics: TopicValueType[] = ['FBR', 'HI', 'CCAF', 'GMF', 'GEMT'];
const CommentsTopics: TopicValueType[] = ['FBR', 'GMF', 'GEMT', 'MS'];
const QuestionIssueSubTopics: TopicValueType[] = ['MS', 'MRMAP'];

export const hotelBookInformationReducer = (state: HotelBookInformationState, action: HotelBookInformationActions) => {
  const { type, payload } = action;
  switch (type) {
    case 'SET_SELECTED_TOPIC':
      return {
        ...state,
        showTypeAndSearchLink: false,
        showCommentsStillHaveAQuestionText: false,
        complimentConcernValue: null,
        showHotelBookInfoSection: HotelBookInfoSectionTopics.includes(payload),
        showTypeAndSearchWithLink: TypeAndSearchWithLinkTopics.includes(payload),
        showHotelServiceDescriptionText: payload === 'HI',
        showComments: CommentsTopics.includes(payload),
        showHotelCreditCardReservationsText: payload === 'CCAF',
        showAboutAStayOption: payload === 'CCAPHS',
        showComplimentConcernAndWebsiteSupportAndMarriottBonvoySubTopic: QuestionIssueSubTopics.includes(payload),
        showMarriottBonvoyAccountLabelWithLinkText: payload === 'MRMAP',
      };
    case 'SET_HOTEL_SEARCH_KEYWORD':
      return {
        ...state,
        matchedHotelsResult: payload?.hotelNames ? payload.hotelNames : null,
        matchedHotelsPropertyId: payload?.hotelPropertyCodes ? payload.hotelPropertyCodes : null,
      };
    case 'SET_COMPLIMENT_CONCERN_VALUE':
      return {
        ...state,
        complimentConcernValue: payload,
        showTypeAndSearchWithLink: true,
        showHotelBookInfoSection: true,
        showComplimentConcernAndWebsiteSupportAndMarriottBonvoySubTopic: payload === 'concern',
        showComments: true,
      };
    case 'RESET_FORM_RENDERED_UI':
      if (payload.selectedTopicType === 'HI') {
        return {
          ...state,
          showComments: payload.shouldRenderUI,
          showCommentsStillHaveAQuestionText: payload.shouldRenderUI,
          showTypeAndSearchLink: payload.shouldRenderUI,
        };
      } else if (payload.selectedTopicType === 'CCAF') {
        return {
          ...state,
          showTypeAndSearchLink: payload.shouldRenderUI,
        };
      } else if (payload.selectedTopicType === 'MRMAP') {
        return {
          ...state,
          showComments: payload.shouldRenderUI,
          showMarriottBonvoyAccountLabelWithLinkText: !payload.shouldRenderUI,
        };
      }
      return state;
    case 'MARRIOTT_BONVOY_SUBTOPIC_DROPDOWN_CHANGE':
      return {
        ...state,
        showComments: payload !== 'CMMBA',
        showMarriottBonvoyAccountLabelWithLinkText: payload === 'CMMBA' || payload === 'ERN',
      };
    case 'SET_SUBTOPICS_LIST':
      return {
        ...state,
        subTopicsList: payload,
      };
    default:
      throw new Error(`Invalid action type: ${type}`);
  }
};
